import { useEffect, useState } from 'react';

const isProd = () => window.location.host === 'campuslush.com';

export enum FeatureFlag {
  EnableFollowButton,
  AdminAnalyticsPage,
  OrganisationLeaderInviteFlow,
  CancelTicketFeature,
  RecurringEvents,
  EnableCoCurricularTab,
}

const getFeatureState = (flag: FeatureFlag, isProd: boolean) => {
  if (flag === FeatureFlag.OrganisationLeaderInviteFlow) return true;
  if (flag === FeatureFlag.EnableFollowButton) return false;
  if (flag === FeatureFlag.AdminAnalyticsPage) return true;
  if (flag === FeatureFlag.CancelTicketFeature) return !isProd;
  if (flag === FeatureFlag.RecurringEvents) return !isProd;
  if (flag === FeatureFlag.EnableCoCurricularTab) return true;

  return false;
};

const useFeature = (flag: FeatureFlag): boolean => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined')
      setIsEnabled(getFeatureState(flag, isProd()));
  }, [flag]);

  return isEnabled;
};

export default useFeature;
